@if (!newBillingDesign) {
  <div id="bill-account-add">
    <form
      [formGroup]="addBillAcctForm"
      (ngSubmit)="verifyBillAccountDetails(addBillAcctForm.value)"
    >
      <div class="row lg-flex items-center">
        <div class="column twelve lg-five pad-bottom-10 lg-pad-bottom-0 lg-pad-right-20">
          <!--
        todo create a ui component for this. see: http://csswizardry.com/2013/05/the-flag-object/
        -->
          <div class="flex items-center">
            <div class="account-add-icon">
              <i class="font-size-2 success-400-text icon-plus-circle"></i>
            </div>
            <div>
              <p class="caption" dsContent [contentPath]="'billing.findBillAcctHeading'"></p>
              <p
                class="caption"
                dsContent
                [contentPath]="'billing.findBillAcctMsg'"
                applicationDependentCopy="true"
              ></p>
            </div>
          </div>
        </div>
        <div class="column twelve lg-seven">
          <div class="row md-flex items-center">
            <div class="column twelve md-six md-pad-right-10 md-inline-form-wrapper">
              <ds-form-control-container
                [labelText]="'Billing Account Number'"
                [control]="addBillAcctForm.get('accountNumber')"
              >
                <input
                  id="accountNumber"
                  class="fill"
                  formControlName="accountNumber"
                  data-cy="billAcctAddAcctNumber"
                />
                <ds-form-control-message
                  class="md-none"
                  [control]="addBillAcctForm.get('accountNumber')"
                ></ds-form-control-message>
              </ds-form-control-container>
            </div>
            <div class="column twelve md-six md-pad-right-10 md-inline-form-wrapper">
              <ds-form-control-container
                [labelText]="'Policy Number'"
                [control]="addBillAcctForm.get('policyNumber')"
              >
                <input
                  id="policyNumber"
                  class="fill"
                  formControlName="policyNumber"
                  data-cy="billAcctAddPolicyNumber"
                />
                <ds-form-control-message
                  class="md-none"
                  [control]="addBillAcctForm.get('policyNumber')"
                ></ds-form-control-message>
              </ds-form-control-container>
            </div>
            <div class="none md-inline-block bill-account-add-cta">
              <button
                ds-button
                class="-outline fill"
                type="submit"
                [disabled]="
                  addBillAcctForm.invalid ||
                  disableAddBillAcctBtn ||
                  (roleService.isAuthorized('registerbillacct_walkthrough') | async) === false
                "
                [attr.aria-label]="findBtnContent"
                data-cy="billAcctAddFindAccountButton"
              >
                {{ findBtnContent }}
              </button>
            </div>
          </div>
          @if (
            (addBillAcctForm.get('accountNumber').invalid ||
              addBillAcctForm.get('policyNumber').invalid) &&
            addBillAcctForm.dirty &&
            addBillAcctForm.invalid
          ) {
            <div class="row none form-control-message md-block">
              <div class="column twelve">
                <div class="row account-add-error">
                  <div class="column twelve md-six md-pad-right-10">
                    <ds-form-control-message
                      class="md-inline-form"
                      [control]="addBillAcctForm.get('accountNumber')"
                    ></ds-form-control-message>
                  </div>
                  <div class="column twelve md-six md-pad-right-10">
                    <ds-form-control-message
                      class="md-inline-form"
                      [control]="addBillAcctForm.get('policyNumber')"
                    ></ds-form-control-message>
                  </div>
                </div>
              </div>
            </div>
          }
          <div class="row block md-none margin-top-10">
            <div class="twelve">
              <button
                ds-button
                class="-outline"
                type="submit"
                [disabled]="
                  addBillAcctForm.invalid ||
                  disableAddBillAcctBtn ||
                  (roleService.isAuthorized('registerbillacct_walkthrough') | async) === false
                "
                [attr.aria-label]="findBtnContent"
              >
                {{ findBtnContent }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
}
@if (!newBillingDesign) {
  <div class="row">
    <div
      class="column twelve pad-vertical-10 md-pad-bottom-0 md-pad-right-10 caption error"
      data-cy="billAcctAddErrorMsg"
    >
      @if (
        billAccountSearchError ||
        ineligibleReasonCode === 'com_amfam_billing_billaccount_IneligibleReasonCode_unspecified'
      ) {
        <p dsContent [contentPath]="'billing.billAccountSearchError'"></p>
      }
      @if (
        ineligibleReasonCode ===
        'com_amfam_billing_billaccount_IneligibleReasonCode_invalidAccountPolicy'
      ) {
        <p dsContent [contentPath]="'billing.registerInvalidBillAcctErrMsg'"></p>
      }
      @if (
        ineligibleReasonCode === 'com_amfam_billing_billaccount_IneligibleReasonCode_aftBilled'
      ) {
        <p dsContent [contentPath]="'billing.registerAftBillAcctErrMsg'"></p>
      }
      @if (
        ineligibleReasonCode === 'com_amfam_billing_billaccount_IneligibleReasonCode_onlineBilled'
      ) {
        <p dsContent [contentPath]="'billing.registerOnlineBillAcctErrMsg'"></p>
      }
      @if (
        ineligibleReasonCode ===
        'com_amfam_billing_billaccount_IneligibleReasonCode_mortgageeAccount'
      ) {
        <p dsContent [contentPath]="'billing.registerMortgageBillAcctErrMsg'"></p>
      }
      @if (
        ineligibleReasonCode ===
        'com_amfam_billing_billaccount_IneligibleReasonCode_someOneElseManagingPref'
      ) {
        <p dsContent [contentPath]="'billing.registersomeOneElseManagingPrefErrMsg'"></p>
      }
      @if (
        ineligibleReasonCode ===
        'com_amfam_billing_billaccount_IneligibleReasonCode_customerNotIdentified'
      ) {
        <p dsContent [contentPath]="'billing.registercustomerNotIdentifiedErrMsg'"></p>
      }
    </div>
  </div>
}
@if (newBillingDesign) {
  <div>
    <div class="flex">
      <img src="assets/images/search-mobile.svg" class="search-img" />
      <span class="label" dsContent [contentPath]="'billing.linkAccount.title'"></span>
    </div>

    @if (!showForm) {
      <button
        ds-button
        class="-outline fill linkBtn"
        [attr.aria-label]="findBtnContent"
        data-cy="billAcctAddFindAccountButton"
        (click)="showAddBillAcctForm()"
        dsContent
        [contentPath]="'billing.linkAccount.linkBtn'"
      ></button>
    }

    @if (showForm) {
      <div class="form">
        <form
          [formGroup]="addBillAcctForm"
          (ngSubmit)="verifyAddBillAccountDetails(addBillAcctForm.value)"
        >
          <div class="column twelve md-inline-form-wrapper link-account-wrapper">
            <div class="error flex" data-cy="billAcctAddErrorMsg">
              @if (
                billAccountSearchError ||
                ineligibleReasonCode ===
                  'com_amfam_billing_billaccount_IneligibleReasonCode_unspecified'
              ) {
                <span class="icon-alert"></span>
                <span dsContent [contentPath]="'billing.billAccountNotFound'"></span>
              }
              @if (
                ineligibleReasonCode ===
                'com_amfam_billing_billaccount_IneligibleReasonCode_invalidAccountPolicy'
              ) {
                <span class="icon-alert"></span>
                <span dsContent [contentPath]="'billing.registerInvalidBillAcctErrMsg'"></span>
              }
              @if (
                ineligibleReasonCode ===
                'com_amfam_billing_billaccount_IneligibleReasonCode_aftBilled'
              ) {
                <span class="icon-alert"></span>
                <span dsContent [contentPath]="'billing.registerAftBillAcctErrMsg'"></span>
              }
              @if (
                ineligibleReasonCode ===
                'com_amfam_billing_billaccount_IneligibleReasonCode_onlineBilled'
              ) {
                <span class="icon-alert"></span>
                <span dsContent [contentPath]="'billing.registerOnlineBillAcctErrMsg'"></span>
              }
              @if (
                ineligibleReasonCode ===
                'com_amfam_billing_billaccount_IneligibleReasonCode_mortgageeAccount'
              ) {
                <span class="icon-alert"></span>
                <span dsContent [contentPath]="'billing.registerMortgageBillAcctErrMsg'"></span>
              }
              @if (
                ineligibleReasonCode ===
                'com_amfam_billing_billaccount_IneligibleReasonCode_someOneElseManagingPref'
              ) {
                <span class="icon-alert"></span>
                <span
                  dsContent
                  [contentPath]="'billing.registersomeOneElseManagingPrefErrMsg'"
                ></span>
              }
              @if (
                ineligibleReasonCode ===
                'com_amfam_billing_billaccount_IneligibleReasonCode_customerNotIdentified'
              ) {
                <span class="icon-alert"></span>
                <span
                  dsContent
                  [contentPath]="'billing.registercustomerNotIdentifiedErrMsg'"
                ></span>
              }
            </div>

            <div class="lifePolicy" dsContent [contentPath]="'billing.linkAccount.life'"></div>

            <div class="formLabel" dsContent [contentPath]="'billing.linkAccount.billAccNo'"></div>
            <ds-form-control-container
              [control]="addBillAcctForm.get('accountNumber')"
              class="inputContainer"
            >
              <input
                id="accountNumber"
                class="fill"
                formControlName="accountNumber"
                data-cy="billAcctAddAcctNumber"
              />
              <ds-form-control-message
                [control]="addBillAcctForm.get('accountNumber')"
                [validateOnSubmit]="submitted"
              ></ds-form-control-message>
            </ds-form-control-container>

            <div class="formLabel" dsContent [contentPath]="'billing.linkAccount.policyNo'"></div>
            <ds-form-control-container
              [control]="addBillAcctForm.get('policyNumber')"
              class="inputContainer"
            >
              <input
                id="policyNumber"
                class="fill"
                formControlName="policyNumber"
                data-cy="billAcctAddPolicyNumber"
              />
              <ds-form-control-message
                [control]="addBillAcctForm.get('policyNumber')"
                [validateOnSubmit]="submitted"
              ></ds-form-control-message>
            </ds-form-control-container>
          </div>
          <div>
            <button
              ds-button
              class="-primary fill form-linkBtn"
              type="submit"
              [attr.aria-label]="findBtnContent"
              data-cy="billAcctAddFindAccountButton"
            >
              {{ linkBtn }}
            </button>
          </div>
        </form>
      </div>
    }
  </div>
}
